import * as React from 'react';

import './Avatar.scss';

interface Props {
  className?: string;
}

const Avatar: React.FC<Props> = ({ children, className }) => {
  return <div className={`avatar ${className ?? ''}`}>{children}</div>;
};

export default Avatar;
